import { Component } from "react";
import Stepper from "../../common/Stepper";
import ImportManager from "./StepsManager";
import RouteManager from "../../../managers/RouteManager";
import { importOptions, supportedFileTypes } from "../EximConstants";
import {
  DKLabel,
  DKButton,
  showToast,
  TOAST_TYPE,
  showLoader,
  removeLoader,
} from "deskera-ui-library";
import Table from "../../../services/table";
import { TableManger, TABLES } from "../../../managers/TableManger";
import JobPipelineService from "../../common/Dashboard/JobPipeline";

class ImportPortal extends Component {
  constructor(props) {
    super(props);

    this.tableName = ImportManager.getQueryParam(this.props.location, "module");
    this.source = ImportManager.getQueryParam(this.props.location, "origin");
    this.steps = ImportManager.getAllCreationSteps(this.onSkipToStep);

    this.state = {
      source: this.source,
      currentStep: 0,
      auditLogId: "",
      fileInfo: null,
      fileContent: null,
      mappedHeaders: null,
      importRecords: null,
      invalidRows: null,
      selectedSegmentId: [],
      jobStageId: [],
      importProperties: JSON.parse(importOptions),
    };
  }

  componentDidMount() {
    RouteManager.setPresenter(this);

    /* TableName Query Param is required to proceed */
    if (!this.tableName) {
      RouteManager.navigateToPage(this.source || "/");
    }

    Table.getRecords(TableManger.getTableId(TABLES.JOB_PIPELINE)).then(
        (response) => {
            this.setState({
                jobPipelines: JobPipelineService.getPipelineData(response)
            });
        }
    );
  }

  uploadRecords = (newFileURL) => {
    if (!newFileURL) {
      Promise.reject("Unable to upload updated records.");
      return;
    }
    const isJobOpeingExisit =  this.state.selectedSegmentId?.find(seg=> typeof seg === 'number')
    const data = {
      properties: this.state.importProperties,
      headers: this.state.mappedHeaders,
      filePath: newFileURL,
      auditLogId: this.state.auditLogId,
      segmentId: isJobOpeingExisit ? this.state.selectedSegmentId: [1, ...this.state.selectedSegmentId],
      jobStageId: this.state.jobStageId,
    };

    ImportManager.uploadRecords(data, this.tableName)
      .then((response) => {
        removeLoader();
        if (response.successCount) {
          showToast(
            `${response.successCount} Candidate(s) imported/updated successfully. 🎉`,
            TOAST_TYPE.SUCCESS
          );
        } else if (response.errorMessage) {
          const errorMessage = JSON.parse(response.errorMessage);
          showToast(errorMessage.error, TOAST_TYPE.FAILURE);
        } else {
          showToast(
            "No records imported, please try again later",
            TOAST_TYPE.FAILURE
          );
        }

        RouteManager.navigateToPage(this.source || "/");
        Promise.resolve();
      })
      .catch((err) => {
        removeLoader();
        showToast(
          "Something went wrong while Importing results, please try again later",
          TOAST_TYPE.FAILURE
        );
      });
  };

  handleImportConfirmation = () => {
    showLoader("Importing Records...");

    ImportManager.uploadNewFile(
      {
        importRecords: this.state.importRecords,
        mappedHeaders: this.state.mappedHeaders,
      },
      "import_candidate",
      supportedFileTypes.CSV
    )
      .then((relativeFileURL) => this.uploadRecords(relativeFileURL))
      .catch((err) => {
        removeLoader();
        showToast(err, TOAST_TYPE.FAILURE);
      });
  };

  isInvalidStep = (expectedStep) => {
    if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

    /* Check if component has required data for expected step */
    const { requiredProps } = this.steps[expectedStep];
    return requiredProps.some(
      (requiredProp) => this.state[requiredProp] === null
    );
  };

  onSkipToStep = (event, index) => {
    const { currentStep } = this.state;

    /* By default expected step is to move forward */
    const expectedStep = index ?? currentStep + 1;

    /* If it's the last step */
    if (expectedStep === this.steps.length) {
      this.handleImportConfirmation();
      return;
    }

    if (this.isInvalidStep(expectedStep)) {
      const errorInfo =
        this.steps[currentStep].reqError ||
        `Sorry can't proceed, please complete the current step first`;
      showToast(errorInfo, TOAST_TYPE.FAILURE);
    } else {
      this.setState({ currentStep: expectedStep });
    }
  };

  handleStepData = (data, callback) => {
    this.setState({ ...data }, callback);
  };

  getCurrentStepChild() {
    const currStep = this.steps[this.state.currentStep];
    return currStep.getChild({
      state: this.state,
      tableName: this.tableName,
      setData: this.handleStepData,
    });
  }

  navigateToPage() {
    RouteManager.navigateToPage(this.source || "/");
  }

  getControllers() {
    const { fileInfo, currentStep } = this.state;
    const isLastStep = currentStep === this.steps.length - 1;
    return isLastStep ? null : (
      <div className="row parent-width justify-content-center mb-l">
        <DKButton
            title="Cancel"
            className="border-m ml-r bg-white"
            onClick={(e) => this.navigateToPage()}
        />
        {currentStep !== 0 && (
          <DKButton
            title="Back"
            className="border-m ml-r bg-white"
            onClick={(e) => this.onSkipToStep(e, currentStep - 1)}
          />
        )}
        {fileInfo && <DKButton
          title="Continue"
          className="border-m ml-r bg-app text-white"
          onClick={this.onSkipToStep}
        />}
      </div>
    );
  }

  render() {
    return (
      <div className="column parent-width">
        <DKLabel text="Import Candidate" className="fw-m fs-l mb-r" />
        <Stepper
          data={this.steps}
          currentIndex={this.state.currentStep}
          className="mb-l"
        />

        <div className="row parent-width m-v-xl justify-content-center">
          {this.getCurrentStepChild()}
        </div>

        {this.getControllers()}
      </div>
    );
  }
}

export default ImportPortal;
